import React, { FC } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Box, Text, ButtonAppearance } from '@bechtel/gds';
import { DrawerFooterButtonStyled } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';
import { DeleteProjectReportModalProps } from './types';

export const DeleteProjectReportModal: FC<DeleteProjectReportModalProps> = ({
  onCancel,
  onDelete,
  textContent,
  title,
}) => {
  return (
    <Modal visible={true} style={{ width: '552px', height: '430px' }}>
      <ModalHeader title={title}></ModalHeader>
      <ModalBody>
        <Box
          px={{ sm: '200' }}
          py={{ sm: '300' }}
          flexDirection={{ sm: 'column' }}
          justifyContent={{ sm: 'center' }}
          alignItems={{ sm: 'center' }}
          flexGrow={{ sm: '1' }}
        >
          <Text size="500" family="graphik" color="grey.1000" weight="600">
            {textContent}
          </Text>
          <Box mt={{ sm: '500' }}>
            <Text size="400" family="graphik" color="grey.1000">
              <Trans>This action cannot be undone.</Trans>
            </Text>
          </Box>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onCancel}>
              <Box px={{ sm: '500' }}>
                <Trans>Cancel</Trans>
              </Box>
            </DrawerFooterButtonStyled>
          </Box>
          <Box>
            <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onDelete}>
              <Box px={{ sm: '500' }}>
                <Trans>Delete</Trans>
              </Box>
            </DrawerFooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
